import API from "./API";

export const getCountryList = async () => {
  return API.get(`ams/countries`)
    .then((response) => response.data)
    .catch((error) => error.response);
};

export const classesList = async (schoolId) => {
  return API.get(`hod/school/${schoolId}/class`)
    .then((response) => response.data)
    .catch((error) => error.response);
};

export const gradesList = async () => {
  return API.get(`/cms/grades?status=active`)
    .then((response) => response.data)
    .catch((error) => error.response);
};

export const teachersList = async (schoolId) => {
  return API.get(`/hod/school/${schoolId}/teacher`)
    .then((response) => response.data)
    .catch((error) => error.response);
};
